import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faScaleBalanced } from '@fortawesome/free-solid-svg-icons';
import './WorkerQASection.css';

/**
 * WorkerQASection - Full-width photo with floating chat bubbles
 *
 * Design based on paidleave.ai style:
 * - Full-width worker photo as background
 * - Chat bubbles floating on the right side
 * - Question bubbles: white/glass with user icon
 * - Answer bubbles: dark slate/glass with scales of justice icon
 * - WCAG AA compliant contrast ratios
 * - Glassmorphism effect with backdrop blur
 */

export function WorkerQASection() {
  const { t } = useTranslation();

  const qaItems = [
    {
      id: 'discrimination',
      question: t('workerQA.items.discrimination.question'),
      answer: t('workerQA.items.discrimination.answer'),
    },
    {
      id: 'promotion',
      question: t('workerQA.items.promotion.question'),
      answer: t('workerQA.items.promotion.answer'),
    },
  ];

  return (
    <section className="worker-qa-section">
      {/* Full-width background image */}
      <img
        src="/story_images/women_on_laptops.png"
        alt={t('workerQA.imageAlt')}
        className="worker-qa-bg-image"
        draggable="false"
      />

      {/* Floating chat bubbles on the right */}
      <div className="worker-qa-bubbles">
        {qaItems.map((item) => (
          <div key={item.id} className="qa-pair">
            {/* Question bubble - white/glass */}
            <div className="qa-bubble qa-bubble-question">
              <div className="qa-avatar qa-avatar-user">
                <FontAwesomeIcon icon={faUser} className="qa-avatar-icon" />
              </div>
              <p className="qa-bubble-text">{item.question}</p>
            </div>

            {/* Answer bubble - dark slate/glass */}
            <div className="qa-bubble qa-bubble-answer">
              <div className="qa-avatar qa-avatar-ai">
                <FontAwesomeIcon icon={faScaleBalanced} className="qa-avatar-icon" />
              </div>
              <p className="qa-bubble-text">{item.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
